// extracted by mini-css-extract-plugin
export default {"wrapper":"nq-z","response":"oq-z","error":"pq-z","disabled":"qq-z","buttons":"rq-z","feedbackQuestionSection":"sq-z","yesNoWrapper":"tq-z"};